import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import { Column, Line } from "@ant-design/charts";
import { Divider, Space, Select, Radio, Checkbox, Tabs } from "antd";
import "./style";
import {
  getOrderCountByYear,
  getOrderCountByYearMonth,
  getOrderCountByYearQuarter,
} from "../../services/Stat";
import { getList as getBuyerList } from "../../services/Buyer";
import { getList as getSupperList } from "../../services/Supplier";
export default React.forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const [group, setGroup] = useState(1);
  const [buyerList, setBuyerList] = useState([]);
  const [selectedBuyerId, setselectedBuyerId] = useState(0);
  const [chartConfig, setChartConfig] = useState({
    height: 300,
    data: [],
    xField: "label",
    yField: "count",
    label: {
      position: 'middle',
      style: {
        fill: '#ffffff'
      },
    },
    maxColumnWidth: "24",
    point: {
      size: 5,
      shape: "diamond",
    },
    tooltip: {
      showMarkers: false,
    },
    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: '#000',
          fill: 'red',
        },
      },
    },
  });
  const [chartType, setChartType] = useState(0);
  const [orderType, setOrderType] = useState('buyer');

  useEffect(() => {
    if (orderType === 'buyer')
    getBuyerList().then((data) => {
      setBuyerList(data);
    });
    else 
    getSupperList().then((data) => {
      setBuyerList(data);
    });
    setselectedBuyerId(0);
  }, [orderType]);
  useEffect(() => {
    if (group === 0) {
      getOrderCountByYear(selectedBuyerId, orderType).then((dt) => {
        const temp = [].concat(
          dt.map((x) => ({ label: x.year, count: x.count }))
        );
        console.log(temp);
        setData(temp);
      });
    } else if (group === 1) {
      getOrderCountByYearMonth(selectedBuyerId, orderType).then((dt) => {
        const temp = [].concat(
          dt.map((x) => ({
            label: x.year + "年" + x.month + "月",
            count: x.count,
          }))
        );
        console.log(temp);
        setData(temp);
      });
    } else if (group === 2) {
      getOrderCountByYearQuarter(selectedBuyerId, orderType).then((dt) => {
        setData(
          dt.map((x) => ({
            label: x.year + "年" + x.quarter + "季度",
            count: x.count,
          }))
        );
      });
    }
  }, [orderType, group, selectedBuyerId]);

  useEffect(() => {
    setChartConfig({
      height: 300,
      data: data,
      xField: "label",
      yField: "count",
      label: chartType === 0 ? {
        position: 'middle',
        style: {
          fill: '#222',
        },
      } : {},
      maxColumnWidth: "25",
      point: {
        size: 5,
        shape: "diamond",
      },
      tooltip: {
        showMarkers: false,
      },
      state: {
        active: {
          style: {
            shadowBlur: 4,
            stroke: '#000',
            fill: 'red',
          },
        },
      },
    });
  }, [data]);

  const onChange = (e) => {
    setselectedBuyerId(e.target.value);
  };

  const onChangeType = (e) => {
    console.log('ordertype:', e.target.value)
    setOrderType(e.target.value);
  };

  let total = 0;
  data.forEach(x=> {
    total+=x.count
  });
  return (
    <div>
      <div className="stat-body-header">
        <strong>请选择订单类型：</strong>
        <Radio.Group value={orderType} onChange={onChangeType}>
          <Radio.Button value='buyer'>客户</Radio.Button>
          <Radio.Button value='supplier'>供应商</Radio.Button>
        </Radio.Group>
      </div>
      <div className="stat-body">
        <div className="dashboard-container">
          <div className="dashboard">
            <div className="group">
              <strong>统计周期：</strong>
              <Radio.Group
                onChange={(e) => setGroup(e.target.value)}
                value={group}
              >
                <Radio value={0}>按年</Radio>
                <Radio value={1}>按月</Radio>
                <Radio value={2}>按季度</Radio>
              </Radio.Group>
              &nbsp;&nbsp;
              <Select value={chartType} onChange={(val) => setChartType(val)}>
                <Select.Option value={0}>柱状图</Select.Option>
                <Select.Option value={1}>折线图</Select.Option>
              </Select>
            </div>
            <div className="title">订单数量统计分析(当前共计：{total})</div>
            <div className="sub-title"></div>
            {chartType === 0 && (
              <Column
                key={"key-" || new Date().getTime()}
                className="chart"
                {...chartConfig}
              />
            )}
            {chartType === 1 && (
              <Line
                key={"key-" || new Date().getTime()}
                className="chart"
                {...chartConfig}
              />
            )}
          </div>
          <div className="data">
            订单数量统计分析明细
            <table
              style={{
                borderTop: "1px solid #ccc",
                borderRight: "1px solid #ccc",
              }}
              className="table"
            >
              <thead>
                <tr className="tr">
                  <th className="td">#</th>
                  <th className="td">周期</th>
                  <th className="td">数量</th>
                  <th className="td">备注</th>
                </tr>
              </thead>
              <tbody>
                {data.map((x, i) => {
                  return (
                    <tr className="tr">
                      <td className="td">{i + 1}</td>
                      <td className="td">
                        <a>{x.label}</a>
                      </td>
                      <td className="td">{x.count}</td>
                      <td className="td">
                       
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="panel">
          <Radio.Group onChange={onChange} value={selectedBuyerId}>
            <Radio value={0}>所有{orderType==='buyer'? '客户' : '供应商'}</Radio>
            <Divider />
            <Space direction="vertical">
              {buyerList.map((x) => {
                return <Radio value={x.id}>{x.name_en || x.name}</Radio>;
              })}
            </Space>
          </Radio.Group>
        </div>
      </div>
    </div>
  );
});
